module.exports = __webpack_public_path__ + "static/media/facebook.a39208fa.png";